const defaultFilterValues = {
  name: '',
  action: '',
  department: ''
};

export default {
  name: 'Schedule',
  components: {
  },
  props: {
    basePath: {
      type: String,
      default: 'ezuro/schedule'
    }
  },
  data () {
    return {
      loading: true,
      currentReq: null,
      tableItems: [],
      filterValues: this.BasicHelper.cloneObject(defaultFilterValues),
      tableSorting: { item: 'id', direction: 'asc' },
      paging: { limit: 20, page: 1, total: 0, pages: 0 },
      isMounted: false
    };
  },
  computed: {
    baseTransParam () {
      return 'event';
    },
    editPermComp () {
      return this.editPerm;
    },
    deletePermComp () {
      return this.editPerm;
    },
    basePathComp () {
      return this.basePath
    },
    tableHeaders () {
      const headers = [
        { key: 'id', label: this.$t('general.item.id'), sortable: false },
        { key: 'department.company_id', label: this.$t('company-structure.company.name'), sortable: false, filterKey: 'company', format: 'formatFromConfig', configKey: 'user_companies', configParam: 'name' },
        { key: 'department_id', label: this.$t('company-structure.department.name'), sortable: false, filterKey: 'department', format: 'formatFromConfig', configKey: 'company_departments', configParam: 'name' },
        { key: 'division_id', label: this.$t('company-structure.division.name'), sortable: false, filterKey: 'division', format: 'formatFromConfig', configKey: 'company_divisions', configParam: 'name' },
        { key: 'type', label: 'Tips', sortable: false, filterKey: 'type', format: 'formatFunc', funcs: [this.translateType] },
        { key: 'date_start', label: 'No', sortable: false, filterKey: 'date_start' },
        { key: 'date_end', label: 'Līdz', sortable: false, filterKey: 'date_end' },
        { key: 'date_for', label: 'Uz datumu', sortable: false, filterKey: 'date_for' },
        { key: 'status', label: 'Status', sortable: false, filterKey: 'status', format: 'formatFunc', funcs: [this.translateStatus] },
        { key: 'approver.fullname', label: 'Apstiprināja', sortable: false }
      ];

      const actions = [];

      if (this.canConfirm) {
        actions.push({ label: this.$t('general.actions.confirm'), emit: 'publishItem', bicon: 'check', class: 'btn-sm btn-primary', ifconfig: { param: 'status', value: 'draft' } });
        actions.push({ label: this.$t('general.cancel'), emit: 'unPublishItem', bicon: 'x', class: 'btn-sm btn-danger', ifconfig: { param: 'status', value: 'confirmed' } });
      }
      actions.push({ label: this.$t('general.actions.delete'), emit: 'deleteItem', bicon: 'trash', class: 'btn-sm btn-danger' });

      headers.push({ key: 'actions', label: '', actions, classTd: 'w-10' });

      return headers;
    },
    tableExpandConfig () {
      return null;
    },
    tableFilterConfig () {
      const filters = { };
      filters.name = { type: 'text', label: '', colOnlyFilter: true };
      filters.department = { type: 'text', label: '', colOnlyFilter: true };
      filters.division = { type: 'text', label: '', colOnlyFilter: true };
      filters.type = { type: 'select', label: '', options: this.typeOptions, colOnlyFilter: true };
      filters.status = { type: 'select', label: '', options: this.statusOptions, colOnlyFilter: true };
      return filters;
    },
    canConfirm () {
      return true;
    },
    typeOptions () {
      const types = [
        { code: 'plan', text: this.$t('work-schedule.type-options.plan') },
        { code: 'view', text: this.$t('work-schedule.type-options.view') },
        { code: 'track', text: this.$t('work-schedule.type-options.track') }
      ];
      return types;
    },
    statusOptions () {
      const options = [
        { code: 'draft', text: this.$t('work-schedule.status-options.draft') },
        { code: 'confirmed', text: this.$t('work-schedule.status-options.confirmed') }
      ];
      return options;
    },
    yesNoOptions () {
      return this.BasicHelper.yesNoOptions();
    },
    requestPath () {
      let path = this.ApiRequest.addGetParamsToPath(this.basePathComp + '/list?perPage=' + this.paging.limit + '&page=' + this.paging.page, this.filterValues, true);

      if (this.tableSorting.item) {
        path += '&order=' + this.tableSorting.item + ',' + this.tableSorting.direction;
      }

      return path;
    },
    tableActions () {
      const actions = { download: false };

      return actions;
    }
  },
  methods: {
    translateType (type) {
      return this.$t('work-schedule.type-options.' + type);
    },
    translateStatus (status) {
      return this.$t('work-schedule.status-options.' + status);
    },
    getDepartmentName (id) {
      return id ? this.$store.getters.getParamFromConfig('company_departments', id, 'name', this.$i18n.locale) : null;
    },
    getTableData () {
      if (this.basePathComp) {
        if (this.currentReq) {
          this.currentReq.cancel('changed search query');
        }

        this.BasicHelper.updateFilterValues(this.$route.name, this.filterValues);
        this.loading = true;
        this.currentReq = this.ApiRequest.request(this.requestPath, this.ApiRequest.REQUEST_GET, {}, (response) => {
          if (response.data) {
            this.tableItems = response.data;
            this.paging = response.paging;
            this.loading = false;
          }
        });
      }
    },
    clearFilters () {
      this.filterValues = this.BasicHelper.cloneObject(defaultFilterValues);
      this.getTableData();
    },
    publishItem (el) {
      const path = 'ezuro/schedule/publish/' + el.id;
      this.isLoading = true;
      this.ApiRequest.request(path, this.ApiRequest.REQUEST_POST, [], (response) => {
        if (response.error) {
          this.ApiRequest.displayErrorDialog(response, this);
        } else {
          this.getTableData();
        }
        this.isLoading = false;
      });
    },
    unPublishItem (el) {
      const path = 'ezuro/schedule/unpublish/' + el.id;
      this.isLoading = true;
      this.ApiRequest.request(path, this.ApiRequest.REQUEST_POST, [], (response) => {
        if (response.error) {
          this.ApiRequest.displayErrorDialog(response, this);
        } else {
          this.getTableData();
        }
        this.isLoading = false;
      });
    },
    changePage (pageNr) {
      this.paging.page = pageNr;
      this.getTableData();
    },
    updateFilter (key, value) {
      if (this.filterValues[key] !== value) {
        this.filterValues[key] = this.BasicHelper.cloneObject(value);
        this.paging.page = 1;
        this.getTableData();
      }
    },
    deleteItem (el, approved) {
      if (approved) {
        this.setDeleted(el, 1);
      } else {
        this.$refs.itemDeleteMsgBox.show(el, this.$t('general.item.deleteTitle'), this.$t('general.item.deleteMessage', { name: this.translateType(el.type), code: this.getDepartmentName(el.department_id) }))
      }
    },
    restoreItem (el) {
      this.setDeleted(el, 0);
    },
    setDeleted (el, isDeleted) {
      this.loading = true;
      this.ApiRequest.request(this.basePathComp + '/destroy/' + el.id, this.ApiRequest.REQUEST_GET, {}, (response) => {
        if (response.error) {
          this.ApiRequest.displayErrorDialog(response, this);
          this.loading = false;
        } else {
          this.getTableData();
        }
      });
    }
  },
  mounted () {
    if (!this.typeId) {
      this.filterValues = this.BasicHelper.fillFilterValues(this.$route.name, this.filterValues, this.$session);
    } else {
      this.filterValues.type_id = this.typeId;
    }
    this.getTableData();
    this.isMounted = true;
  },
  watch: {
    basePathComp: {
      immediate: true,
      handler (val) {
        if (val) {
          this.isMounted = false;
          if (!this.typeId) {
            this.filterValues = this.BasicHelper.fillFilterValues(this.$route.name, this.filterValues, this.$session);
          } else {
            this.filterValues.type_id = this.typeId;
          }
          this.getTableData();
          this.isMounted = true;
        }
      }
    }
  }
}
